import { characterConst, converterType } from '../utils/constant'
import { StoryWord } from 'types/wordDictionaryTypes'
import { membershipNameType } from 'utils/constant'

export const converterWord = (word: string, characterPreference: string) =>
  word
    ? characterPreference === characterConst.traditional
      ? converterType.converterTraditional(word)
      : converterType.converterSimplified(word)
    : word

export const renderConverterWord = (word: string, characterPreference: string) => {
  return characterPreference === characterConst.traditional
    ? converterType.converterTraditional(word)
    : converterType.converterSimplified(word)
}

export const wordSimplified = (word: string) => word && converterType.converterSimplified(word)

export const findWordInArray = (word: string, characterPreference: string, wordArray?: StoryWord[]) =>
  wordArray?.find(
    (wordDetail) => converterWord(word, characterPreference) === converterWord(wordDetail?.word, characterPreference),
  )

export const getWordTypeFromStory = (word: string, story: any, characterPreference: string) => {
  const newWord = findWordInArray(word, characterPreference, story?.newWordsArray)
  const learningWord = findWordInArray(word, characterPreference, story?.learningWords)
  const growingWord = findWordInArray(word, characterPreference, story?.growingWords)
  const developingWord = findWordInArray(word, characterPreference, story?.developingWords)
  const masteredWord = findWordInArray(word, characterPreference, story?.masteredWords)
  return getWordType(newWord, learningWord, growingWord, developingWord, masteredWord)
}

export const getWordType = (newWord, learningWord, growingWord, developingWord, masteredWord) => {
  return newWord
    ? 'New'
    : learningWord
      ? 'Learning'
      : growingWord
        ? 'Growing'
        : developingWord
          ? 'Developing'
          : masteredWord
            ? 'Mastered'
            : 'word'
}

export const removeSpaceBetweenWords = (str: string): string => str?.replace(/ +/g, '')?.toLowerCase()

export const getWordLine = (wordArray) =>
  wordArray
    ?.map((wordInfo) => wordInfo?.word)
    ?.toString()
    ?.replace(/<\/?p>/g, '')
    ?.replace(/,/, '')
    ?.replace(/,/g, '')
    ?.trim()

// The words of a tapped line, without the <p> markers the story content carries, so the
// word pocket can keep the sentence a word came from and show it segmented.
export const getSentenceWords = (wordArray): string[] =>
  (wordArray || [])
    .map((wordInfo) => (typeof wordInfo === 'string' ? wordInfo : wordInfo?.word))
    .filter((word) => typeof word === 'string')
    .map((word) => word.replace(/<\/?p>/g, '').trim())
    .filter(Boolean)

export const getWordTypeClass = (wordType) => {
  switch (wordType) {
    case 'New':
      return ['new_bg_color', '', '', '', '']
    case 'Learning':
      return ['learning_bg_color', 'learning_bg_color', '', '', '']
    case 'Growing':
      return ['growing_bg_color', 'growing_bg_color', 'growing_bg_color', '', '']
    case 'Developing':
      return ['developing_bg_color', 'developing_bg_color', 'developing_bg_color', 'developing_bg_color', '']
    case 'Mastered':
      return new Array(5).fill('mastered_bg_color')
    case 'word':
      return null
    default:
      return new Array(5).fill('')
  }
}

export const formatTimer = (t: number) => {
  const m = Math.floor(t / 60)
    .toString()
    .padStart(2, '0')
  const s = (t % 60).toString().padStart(2, '0')
  return `${m}:${s}`
}

export const getPriceInNumber = (price: string) => Number(price?.replace('$', ''))

export const isEnableStreaking = (membershipPlan: string): boolean =>
  membershipPlan === membershipNameType.Free ? false : true
